import { BudgetHistory } from "../../../types";
import { getStatusBadgeClass, getRecipientLabel } from "../../../../budgetsKanban/utils/statusHelpers";

interface BudgetHistoryModalMobileProps {
  consultant: string;
  currentVersion: BudgetHistory;
  versions: BudgetHistory[];
  onViewBudget: (version: BudgetHistory) => void;
}

const BudgetHistoryModalMobile = ({
  consultant,
  currentVersion,
  versions,
  onViewBudget,
}: BudgetHistoryModalMobileProps) => {
  return (
    <div className="p-2">
      {currentVersion && (
        <div className="mb-6">
          <h3 className="text-size-14 font-semibold mb-4">
            Histórico de atualizações
          </h3>
          <div className="bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-700 rounded-lg p-3 mb-4">
            <div className="flex flex-col gap-2">
              <div>
                <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Consultor: </span>
                <span className="text-size-14 text-gray-800 dark:text-neutral-200">{consultant}</span>
              </div>
              <div>
                <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Destinatário: </span>
                <span className="text-size-14 text-gray-800 dark:text-neutral-200">{getRecipientLabel(currentVersion.user)}</span>
              </div>
              <div>
                <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Versão: </span>
                <span className="text-size-14 text-gray-800 dark:text-neutral-200">v {currentVersion.version}.0</span>
              </div>
              <div>
                <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Data: </span>
                <span className="text-size-14 text-gray-800 dark:text-neutral-200">{currentVersion.versionDate}</span>
              </div>
              <div>
                <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Status: </span>
                <span
                  className={`inline-block px-3 py-1 rounded-full text-size-12 font-medium ${getStatusBadgeClass(currentVersion.status)}`}
                >
                  {currentVersion.status}
                </span>
              </div>
              <div className="mt-2">
                <button
                  onClick={() => onViewBudget(currentVersion)}
                  className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline flex items-center gap-2 text-size-14"
                >
                  <span className="rioglyph rioglyph-file"></span>
                  <span>Visualizar orçamento</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="mt-6">
        <h3 className="text-size-14 font-semibold mb-4">
          Histórico de alterações:
        </h3>
        <div className="flex flex-col gap-3">
          {versions.map((version, index) => (
            <div
              key={`${version.id}-${version.version}-${index}`}
              className="bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-700 rounded-lg p-3"
            >
              <div className="flex flex-col gap-2">
                <div>
                  <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Perfil: </span>
                  <span className="text-size-14 text-gray-800 dark:text-neutral-200">{version.profile}</span>
                </div>
                <div>
                  <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Versão: </span>
                  <span className="text-size-14 text-gray-800 dark:text-neutral-200">v {version.version}.0</span>
                </div>
                <div>
                  <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Data: </span>
                  <span className="text-size-14 text-gray-800 dark:text-neutral-200">{version.versionDate}</span>
                </div>
                <div>
                  <span className="text-size-12 font-semibold text-gray-600 dark:text-neutral-400">Status: </span>
                  <span
                    className={`inline-block px-3 py-1 rounded-full text-size-12 font-medium ${getStatusBadgeClass(version.status)}`}
                  >
                    {version.status}
                  </span>
                </div>
                <div className="mt-2">
                  <button
                    onClick={() => onViewBudget(version)}
                    className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline flex items-center gap-2 text-size-14"
                  >
                    <span className="rioglyph rioglyph-file"></span>
                    <span>Visualizar orçamento</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BudgetHistoryModalMobile;
